import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";
var _class, _descriptor, _descriptor2;
import { action, computed, observable } from 'mobx';
import { Model } from 'core/model/Model';
import $dictionary from 'app/stores/$dictionary';
import $interfaceClass from 'app/stores/interface/$interfaceClass';
let RuleModel = (_class = class RuleModel extends Model {
  constructor(...args) {
    super(...args);
    // tracks whether or not a rule has been evaluated at least once.
    _initializerDefineProperty(this, "isTested", _descriptor, this);
    // TODO is this actually populated?
    this.kentik_managed_rule = void 0;
    _initializerDefineProperty(this, "toggleEnabled", _descriptor2, this);
  }
  get defaults() {
    return {
      rank: 0,
      enabled: true,
      auto_classify: true,
      match_clause: {
        match_attribute: 'snmp_alias',
        match_operand: 'contains',
        pattern: ''
      },
      action_set: {
        set_network_boundary: 'auto',
        set_connectivity_type: 'other'
      },
      interfacesClassified: [],
      interfacesMatched: []
    };
  }
  get urlRoot() {
    return '/api/ui/interfaces/rules';
  }
  get omitDuringSerialize() {
    return ['num_matches'];
  }
  get messages() {
    return {
      create: 'Rule was added successfully',
      update: 'Rule was updated successfully',
      destroy: 'Rule was removed successfully'
    };
  }
  get readableDisplay() {
    const {
      match_operand,
      match_attribute,
      pattern
    } = this.get('match_clause');
    return {
      attribute: $dictionary.get(`interfaceClassification.matchAttributes.${match_attribute}`),
      operand: $dictionary.get(`interfaceClassification.operands.${match_operand}`),
      pattern
    };
  }
  get isPublicOrPrivateIP() {
    const {
      match_operand
    } = this.get('match_clause');
    return match_operand === 'is_public_ip' || match_operand === 'is_private_ip' || match_operand === 'no_ip';
  }
  get translated_network_boundary() {
    const {
      set_connectivity_type,
      set_network_boundary
    } = this.get('action_set');
    if (set_network_boundary === 'auto') {
      return $interfaceClass.getDefaultNetworkBoundary(set_connectivity_type);
    }
    return set_network_boundary;
  }
  get action_string() {
    const {
      set_connectivity_type
    } = this.get('action_set');
    return {
      set_connectivity_type: $dictionary.get(`interfaceClassification.connectivityTypes.${set_connectivity_type}`),
      set_network_boundary: $dictionary.get(`interfaceClassification.networkBoundaryTypes.${this.translated_network_boundary}`)
    };
  }
  get match_attribute() {
    return $dictionary.get(`interfaceClassification.matchAttributes.${this.get('match_clause').match_attribute}`);
  }
  get match_operand() {
    const operand = this.get('match_clause').match_operand;
    return operand && $dictionary.get(`interfaceClassification.operands.${operand}`);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "isTested", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, "readableDisplay", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "readableDisplay"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isPublicOrPrivateIP", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isPublicOrPrivateIP"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "translated_network_boundary", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "translated_network_boundary"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "action_string", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "action_string"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "match_attribute", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "match_attribute"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "match_operand", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "match_operand"), _class.prototype), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "toggleEnabled", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return () => {
      this.save({
        enabled: !this.get('enabled')
      }, {
        toast: false
      });
    };
  }
}), _class);
export default RuleModel;